import {useTranslation} from "react-i18next";
import {Form, Formik} from "formik";

import {
  addNewKitImages,
  addNewSampleImages,
  deleteKitImage,
  deleteSampleImage,
} from "../../../../slices/SampleFunctionalSlice";
import Divider from "../../../../utilities/Divider/Divider";
import {TextInput} from "../../../Inputs";
import KitSampleTableModalPart from "../../../SamplesList/SampleUniModal/SampleUniModalParts/KitSampleTableModalPart";
import QRSampleModalPart from "../../../SamplesList/SampleUniModal/SampleUniModalParts/QRSampleModalPart";
import SampleTabPart from "../../../SamplesListNew/SampleTabPart/SampleTabPart";
import useUpdateTab from "../../../SamplesListNew/tabs/useUpdateTab";
import KitTabPart from "../../KitTabPart/KitTabPart";

import useCreateKitSamplesTab from "./useCreateKitSamplesTab";

const CreateKitSamplesTabBase = () => {
  const {t} = useTranslation();

  const {typeForm, newSample, sampleImgs, currentKit, kitImages, currentSampleId, setCurrentSampleId} =
    useCreateKitSamplesTab();

  useUpdateTab({typeForm});

  return (
    <div className="h100">
      <div className="h100" style={{paddingTop: "1em"}}>
        <Form className="fcCol h100">
          <div className="fc jcfe aibl">
            <TextInput label={t("BM")} width="17em" name="brandManager" disabled />
          </div>
          <Divider />
          <div className={`w ${"block_opacity"}`}>
            <KitTabPart typeForm={typeForm} />
            <QRSampleModalPart
              isCreate={false}
              typeForm={typeForm}
              kit={currentKit}
              images={kitImages}
              addMethod={addNewKitImages}
              deleteMethod={deleteKitImage}
            />
          </div>
          <div className="border border_gap"></div>
          <div className="w">
            <SampleTabPart typeForm={typeForm} kitId={currentKit?.kitId} setCurrentSampleId={setCurrentSampleId} />
            <QRSampleModalPart
              typeForm={typeForm}
              isCreate={true}
              sample={newSample}
              images={sampleImgs}
              addMethod={addNewSampleImages}
              deleteMethod={deleteSampleImage}
            />
          </div>
          <div className="border border_gap"></div>
          <KitSampleTableModalPart
            typeForm={typeForm}
            complectChecked={true}
            currentSampleId={currentSampleId}
            setCurrentSampleId={setCurrentSampleId}
          />
        </Form>
      </div>
    </div>
  );
};

const CreateKitSamplesTab = () => {
  const {validationSchema, initialValues} = useCreateKitSamplesTab();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      enableReinitialize
    >
      <CreateKitSamplesTabBase />
    </Formik>
  );
};

export default CreateKitSamplesTab;
